import { HashRouter as BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import "./App.css";
import { SettingsProvider } from "./lib/SettingsContext";

import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Chatbot from "./components/Chatbot";

import Home from "./pages/Home";
import About from "./pages/About";
import Flavours from "./pages/Flavours";
import Shop from "./pages/Shop";
import CakeDetail from "./pages/CakeDetail";
import Contact from "./pages/Contact";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminFlavours from "./pages/admin/AdminFlavours";
import AdminCakes from "./pages/admin/AdminCakes";
import AdminBlogs from "./pages/admin/AdminBlogs";
import AdminInquiries from "./pages/admin/AdminInquiries";
import AdminSettings from "./pages/admin/AdminSettings";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
    return null;
}

function PublicLayout({ children }) {
    return (
        <>
            <Navbar />
            {children}
            <Footer />
            <Chatbot />
        </>
    );
}

function App() {
    return (
        <SettingsProvider>
            <div className="App">
                <BrowserRouter>
                    <ScrollToTop />
                    <Toaster position="bottom-right" richColors />
                    <Routes>
                        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
                        <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
                        <Route path="/flavours" element={<PublicLayout><Flavours /></PublicLayout>} />
                        <Route path="/shop" element={<PublicLayout><Shop /></PublicLayout>} />
                        <Route path="/shop/:slug" element={<PublicLayout><CakeDetail /></PublicLayout>} />
                        <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
                        <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
                        <Route path="/blog/:slug" element={<PublicLayout><BlogDetail /></PublicLayout>} />

                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminLayout />}>
                            <Route index element={<AdminDashboard />} />
                            <Route path="cakes" element={<AdminCakes />} />
                            <Route path="flavours" element={<AdminFlavours />} />
                            <Route path="blogs" element={<AdminBlogs />} />
                            <Route path="inquiries" element={<AdminInquiries />} />
                            <Route path="settings" element={<AdminSettings />} />
                        </Route>
                    </Routes>
                </BrowserRouter>
            </div>
        </SettingsProvider>
    );
}

export default App;
